<template>
  <div class="modal" :class="{ 'is-active': is_active }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ is_editing ? $t("edit subtask") : $t("create subtask") }}
        </p>
        <button class="delete" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <div class="field">
          <label class="label">{{ $t("title") }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="meta.title"
              :placeholder="$t('title')"
            />
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t("description") }}</label>
          <div class="control">
            <textarea
              class="textarea"
              v-model="meta.description"
              :placeholder="$t('description')"
              rows="3"
            ></textarea>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("status") }}</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="meta.status">
                    <option value="pending">{{ $t("pending") }}</option>
                    <option value="in_progress">{{ $t("in progress") }}</option>
                    <option value="completed">{{ $t("completed") }}</option>
                    <option value="cancelled">{{ $t("cancelled") }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("priority") }}</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="meta.priority">
                    <option value="low">{{ $t("low") }}</option>
                    <option value="medium">{{ $t("medium") }}</option>
                    <option value="high">{{ $t("high") }}</option>
                    <option value="critical">{{ $t("critical") }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="field">
          <generic-dropdown
            :title="$t('assigned user')"
            :placeholder="$t('select user')"
            url="/access/user/catalog"
            name_field="username"
            value_field="user_id"
            @selected="set_assigned_user"
            ref="user_dropdown"
            :is_multiple="false"
          />
        </div>

        <div class="field">
          <label class="label">{{ $t("due date") }}</label>
          <div class="control">
            <input class="input" type="date" v-model="meta.due_date" />
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-rounded is-primary"
          @click="save"
          :disabled="is_form_invalid"
        >
          <span class="icon">
            <i class="fa fa-save"></i>
          </span>
          <span>{{ $t("save") }}</span>
        </button>
        <button class="button is-rounded ml-3" @click="close_modal">
          <span class="icon">
            <i class="fa fa-close"></i>
          </span>
          <span>{{ $t("cancel") }}</span>
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { put, post, get, error_message, success_message } from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "SubtaskModal",
  components: { GenericDropdown },
  data() {
    return {
      is_active: false,
      is_editing: false,
      parent_task_uuid: "",
      meta: {
        title: "",
        description: "",
        status: "pending",
        priority: "medium",
        due_date: "",
        assigned_user_id: null,
        settings: {},
      },
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return !v.meta.title || !v.meta.description || !v.meta.due_date;
    },
  },
  methods: {
    show_modal(parent_task_uuid) {
      let v = this;
      v.set_initial_state();
      v.parent_task_uuid = parent_task_uuid;
      v.is_editing = false;
      v.is_active = true;
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();
      v.is_editing = true;
      v.is_active = true;
      v.load_data(uuid);
    },
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.is_active = false;
      v.parent_task_uuid = "";
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        title: "",
        description: "",
        status: "pending",
        priority: "medium",
        due_date: "",
        assigned_user_id: null,
        settings: {},
      };
      if (v.$refs.user_dropdown) {
        v.$refs.user_dropdown.clear();
      }
    },
    load_data(uuid) {
      let v = this;
      get("/task/subtask", { uuid: uuid })
        .then((response) => {
          let subtask = response;
          v.meta = {
            uuid: subtask.uuid,
            title: subtask.title,
            description: subtask.description,
            status: subtask.status,
            priority: subtask.priority,
            due_date: subtask.due_date,
            assigned_user_id: subtask.assigned_user_id,
            settings: subtask.settings || {},
          };
          v.parent_task_uuid = subtask.parent_task_uuid;

          // Set the assigned user in the dropdown if exists
          if (subtask.assigned_user_id && v.$refs.user_dropdown) {
            v.$refs.user_dropdown.set_value(subtask.assigned_user_id);
          }
        })
        .catch((error) => {
          error_message(error);
        });
    },
    set_assigned_user(user) {
      let v = this;
      if (user) {
        v.meta.assigned_user_id = user.user_id;
      } else {
        v.meta.assigned_user_id = null;
      }
    },
    save() {
      let v = this;
      let request_method = v.is_editing ? post : put;
      let success_message_text = v.is_editing
        ? v.$t("subtask updated successfully")
        : v.$t("subtask created successfully");

      let data = { ...v.meta };
      if (!v.is_editing) {
        data.parent_task_uuid = v.parent_task_uuid;
      }

      request_method("/task/subtask", data)
        .then(() => {
          success_message(success_message_text);
          v.$emit("success");
          v.close_modal();
        })
        .catch((error) => {
          error_message(error);
        });
    },
  },
};
</script>

<style scoped></style>
